import SelectService from "../../components/SelectService";

const Server6 = () => {
  return (
    <>
      <SelectService server={'6'} />
    </>
  );
};

export default Server6;
